import Phaser from "phaser";
import { BOAT_DAMPING, BOAT_ROTATION_LERP, BOAT_SPEED } from "../../game/constants";
import { PlayerInput } from "./PlayerInput";

export class BoatController {
    readonly sprite: Phaser.Physics.Arcade.Sprite;
    private readonly input: PlayerInput;
    private speedMultiplier = 1;

    constructor(scene: Phaser.Scene, x: number, y: number, getVirtualDirection?: () => Phaser.Math.Vector2) {
        this.sprite = scene.physics.add.sprite(x, y, "boat");
        this.sprite.setDamping(true);
        this.sprite.setDrag(1 - BOAT_DAMPING);
        this.sprite.setMaxVelocity(BOAT_SPEED * 1.5);
        this.sprite.setDepth(10);
        this.sprite.setCollideWorldBounds(true);
        this.input = new PlayerInput(scene, getVirtualDirection);
    }

    update(): boolean {
        const direction = this.input.getDirection();
        const moving = direction.lengthSq() > 0;
        if (moving) {
            this.sprite.setAcceleration(direction.x * BOAT_SPEED * this.speedMultiplier, direction.y * BOAT_SPEED * this.speedMultiplier);
            const targetRotation = direction.angle();
            this.sprite.rotation = Phaser.Math.Angle.RotateTo(this.sprite.rotation, targetRotation, BOAT_ROTATION_LERP);
        } else {
            this.sprite.setAcceleration(0, 0);
        }

        return moving;
    }

    setSpeedMultiplier(multiplier: number): void {
        this.speedMultiplier = multiplier;
    }
}
